import { createModule } from '../../createModule';
export const createFactsheetsAPI = createModule(({ http }) => {
    return {
        createIndicative: async (body) => {
            const res = await http.post('/v2/factsheets/indicative', {
                body: body,
                responseType: 'arraybuffer',
            });
            return res;
        },
        createFinal: async (body) => {
            const res = await http.post('/v2/factsheets/final', {
                body: body,
                responseType: 'arraybuffer',
            });
            return res;
        },
    };
});
